// export default Login;
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios, { AxiosError } from "axios";
import React, { SyntheticEvent, useState, useEffect } from 'react';
import { Module } from '../models/module';
import { BRAND } from '../generated/brand';
import { clearAuthToken, setAuthToken } from '../utils/auth-storage';

import logo from '../logoFull.png'
function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {`Copyright © ${BRAND.legalName}`}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
interface Props {
    setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
    setModules: React.Dispatch<React.SetStateAction<Module[]>>;
}
const SignInSide: React.FC<Props> = ({ setIsAuthenticated, setModules }) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
    };
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const submit = async (event: SyntheticEvent) => {
        event.preventDefault();
        const formData = { username, password };
        const url = 'login';

        try {
            const response = await axios.post(url, formData);
            if (response.data?.token) {
                setAuthToken(response.data.token);
            } else {
                clearAuthToken();
            }
            sessionStorage.setItem('isAuthenticated', 'true');
            setIsAuthenticated(true);
            setModules(response.data.data);
            sessionStorage.setItem('modules', JSON.stringify(response.data.data));
            localStorage.setItem('modules', JSON.stringify(response.data.data));
            navigate('/');
        } catch (error: any) {
            if (error.response && error.response.data.message) {
                setErrorMessage(error.response.data.message);
                setPassword('');
            } else {
                setErrorMessage('An unexpected error occurred.');
                setPassword('');
            }
            console.error('Error:', error);
        }
    };

    document.title = `${BRAND.web.loginTitle} - ${BRAND.displayName}`;
    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid
                container
                component="main"
                sx={{
                    height: '100vh', // Ocupar toda la altura de la pantalla
                    display: 'flex',
                    justifyContent: 'center', // Centrar horizontalmente
                    alignItems: 'center', // Centrar verticalmente
                }}
            >
                <CssBaseline />
                <Grid
                    item
                    xs={12} // Ocupar todo el ancho
                    sm={12}
                    md={12}
                    component={Paper}
                    elevation={6}
                    square
                    sx={{
                        height: '100vh', // Ocupar toda la altura de la pantalla
                        display: 'flex',
                        justifyContent: 'center', // Centrar horizontalmente
                        alignItems: 'center', // Centrar verticalmente
                    }}
                >
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%', // Ocupar todo el ancho disponible
                            maxWidth: '400px', // Limitar el ancho máximo del formulario
                        }}
                    >
                        {errorMessage && (
                            <Grid item xs={12} sm={8} md={5}>
                                <Alert severity="error">{errorMessage}</Alert>
                            </Grid>
                        )}
                        {/* Logo visible solo en pantallas grandes */}
                        <Box
                            component="img"
                            src={BRAND.web.assetUrls.logoFull || logo}
                            alt="Logo"
                            sx={{
                                width: { xs: '280px', sm: '320px' },
                                height: 'auto',
                                display: 'block',
                                objectFit: 'contain',
                                marginBottom: '16px',
                            }}
                        />
                        <Box component="form" noValidate onSubmit={submit} sx={{ mt: 1, width: '100%' }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Nombre de Usuario"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                onChange={event => setUsername(event.target.value)}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={event => setPassword(event.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={submit}
                            >
                                Sign In
                            </Button>
                            <Grid container>
                                {/* Otros elementos del formulario */}
                            </Grid>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}

export default SignInSide;
